import React from 'react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import { __ } from '@wordpress/i18n';

// components
import ActivityList from '../../../../components/CommCenter/components/ActivityList';
import SectionHeader from '../../../../components/CommCenter/components/SectionHeader';
import WalkthroughBox from '../../../../components/CommCenter/components/WalkthroughBox';

// store
import { CommCenterProvider, useCommCenter } from '../../../../components/CommCenter/context';

const CommCenterProjectsInner = () => {
    const {
        visibleActivities,
        unreadActivityCount,
        showArchived,
        setShowArchived,
        loading,
    } = useCommCenter();

    return (
        <div className="appCommCenter">
            <div className="commCenter__top">
                <WalkthroughBox/>
                <SectionHeader
                    title={showArchived
                        ? __('Attività archiviate', 'soundbetween')
                        : __('Nuove attività', 'soundbetween')}
                    count={showArchived ? 0 : unreadActivityCount}
                    archiveActive={showArchived}
                    onToggleArchive={() => setShowArchived(!showArchived)}/>
            </div>
            <OverlayScrollbarsComponent
                element="div"
                className="commPanel"
                options={{ scrollbars: { autoHide: 'never' } }}
                defer>
                <ActivityList
                    activities={visibleActivities}
                    emptyLabel={loading
                        ? __('Carico le attività…', 'soundbetween')
                        : showArchived
                            ? __('L’archivio è vuoto.', 'soundbetween')
                            : __('Nessuna attività recente.', 'soundbetween')}/>
            </OverlayScrollbarsComponent>
        </div>
    )
}

/**
 * Projects page sidebar: a single cross project feed, with the onboarding box
 * on top. No tabs — communications live inside each project.
 */
const CommCenterProjects = () => {
    return (
        <CommCenterProvider scope="me" cueTarget="studio">
            <CommCenterProjectsInner/>
        </CommCenterProvider>
    )
}

export default CommCenterProjects;
